import { render, staticRenderFns } from "./comany_list.vue?vue&type=template&id=37d4fa68&"
import script from "./comany_list.vue?vue&type=script&lang=js&"
export * from "./comany_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\azqf-sys\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d4fa68')) {
      api.createRecord('37d4fa68', component.options)
    } else {
      api.reload('37d4fa68', component.options)
    }
    module.hot.accept("./comany_list.vue?vue&type=template&id=37d4fa68&", function () {
      api.rerender('37d4fa68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comany_list.vue"
export default component.exports